module.exports = __webpack_public_path__ + "static/media/claim.684d7034.png";